/**
 * User Diagnostics API Service
 * 
 * API calls for admin user diagnostics.
 */

import axios from "axios";
import { getApiBase } from "./apiConfig";

const API_BASE_URL = getApiBase();

export interface ExecutionJob {
  job_id: string;
  job_type: string;
  status: string;
  attempts: number;
  last_error?: string | null;
  last_error_code?: string | null;
  error_category?: string | null;
  position_id?: string | null;
  recommendation_id?: string | null;
  signal_id?: string | null;
  created_at?: string | null;
  started_at?: string | null;
  completed_at?: string | null;
  job_payload_json?: Record<string, unknown> | null;
  meta_json?: Record<string, unknown> | null;
}

export interface UserPosition {
  id: string;
  symbol: string;
  state: string;
  entry_price?: number | null;
  exit_price?: number | null;
  qty?: number | null;
  notional_usdt?: number | null;
  fees_usdt?: number | null;
  entry_order_id?: string | null;
  exit_order_id?: string | null;
  created_at: string;
  updated_at: string;
}

export interface PaymentIntent {
  id: string;
  status: string;
  amount_usdt?: number | null;
  tx_hash?: string | null;
  rejection_reason?: string | null;
  created_at: string;
  verified_at?: string | null;
}

export interface Payment {
  id: string;
  intent_id?: string | null;
  status: string;
  amount_usdt?: number | null;
  created_at: string;
}

export interface UserDiagnosticsResponse {
  user_id: string;
  execution_jobs: ExecutionJob[];
  positions: UserPosition[];
  payment_intents: PaymentIntent[];
  payments: Payment[];
  timestamp: string;
}

/**
 * Get user diagnostics (admin only)
 */
export async function getUserDiagnostics(userId: string): Promise<UserDiagnosticsResponse> {
  const response = await axios.get<UserDiagnosticsResponse>(
    `${API_BASE_URL}/admin/users/${userId}/diagnostics`,
  );
  return response.data;
}

